/**
 * Neutral surface palette for Tailwind utilities (bg-surface-muted, border-surface-subtle, …).
 * Intentionally separate from DaisyUI base-* so app surfaces do not depend on theme base overrides.
 */
module.exports = {
	DEFAULT: "#FFFFFF",
	muted: "#EDEFF1",
	subtle: "#CDD2D8",
	strong: "#68778A",
};
